// Module
var code = "<h1 data-bind=\"text: _errorMessage\"></h1>";
// Exports
export default code;